import { render, staticRenderFns } from "./ProfileChangeUserAge.vue?vue&type=template&id=7fc681f6&scoped=true"
import script from "./ProfileChangeUserAge.vue?vue&type=script&lang=js"
export * from "./ProfileChangeUserAge.vue?vue&type=script&lang=js"
import style0 from "./ProfileChangeUserAge.vue?vue&type=style&index=0&id=7fc681f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc681f6",
  null
  
)

export default component.exports